import React from 'react';

const Breadcrumbs = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="breadcrumbs">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.link ? (
            <a href={item.link} className="breadcrumb-link">
              {item.label}
            </a>
          ) : (
            <span className="breadcrumb-text">{item.label}</span>
          )}
          {index < items.length - 1 && (
            <i className="fas fa-chevron-right"></i>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumbs;